'use client';

import { useForm } from 'react-hook-form';

import { useChangePassword } from './hooks';

type FormData = {
    email: string;
};

export function RequestPasswordReset() {
    const { requestReset, requestResetError, isRequestResetSuccess } =
        useChangePassword();

    const form = useForm<FormData>();
    const {
        formState: { errors },
    } = form;

    if (isRequestResetSuccess)
        return <>Reset email will be sent to provided email shortly.</>;

    const handleSubmit = form.handleSubmit((payload) => {
        requestReset(payload.email);
    });

    return (
        <>
            <form className="form form--password-reset" onSubmit={handleSubmit}>
                <div className="form__element">
                    <label htmlFor="reset-email">Email Address*</label>
                    {errors.email?.type === 'required' && (
                        <p role="alert">Your email address is required</p>
                    )}
                    {requestResetError ? (
                        <p className="form__warning">{requestResetError}</p>
                    ) : null}
                    <input
                        {...form.register('email', { required: true })}
                        type="email"
                        id="reset-email"
                        style={{ width: '100%', maxWidth: '300px' }}
                    />
                </div>
                <button type="submit" className="form__button">
                    Send password reset link
                </button>
            </form>
        </>
    );
}
